import React from 'react';

export interface TextAreaProps {
  id: string;
  name: string;
  rows: number;
  placeholder: string;
  value?: string | null;
  label?: string;
  setValue?: React.Dispatch<React.SetStateAction<string | any>>;
  defaultValue?: string;
  disabled?: boolean;
  button?: {
    text: string;
    onClick: () => void | Promise<void>;
    disabled?: boolean;
  };
}

const isEmpty = (str?: string | null): boolean => {
  return !str || str.trim().length == 0;
};

export const TextArea = (props: TextAreaProps) => {
  return (
    <div>
      {props.label && (
        <label htmlFor={props.id} className="block text-sm/6 font-medium mt-6 text-gray-900">
          {props.label}
        </label>
      )}
      <div className="mt-2 sm:flex sm:items-center">
        <div className="w-full">
          <textarea
            disabled={!!props.disabled}
            id={props.id}
            name={props.name}
            rows={props.rows}
            placeholder={props.placeholder}
            className="block w-full rounded-md bg-white px-3 py-1.5 text-base
          text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300
           placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2
           focus:outline-indigo-600 sm:text-sm/6"
            defaultValue={props.defaultValue}
            value={isEmpty(props.value) ? undefined : props.value!}
            onChange={(event) => {
              if (props.setValue) {
                props.setValue(event.target.value);
              }
            }}
          />
        </div>
        {props.button && (
          <button
            type="button"
            disabled={props.button.disabled}
            onClick={props.button.onClick}
            className="inline-flex w-full items-center justify-center rounded-md bg-indigo-600 px-3
                py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline
                focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:ml-3
                sm:mt-0 sm:w-auto"
          >
            {props.button.text}
          </button>
        )}
      </div>
    </div>
  );
};
